import { setGADataLayer } from 'analytics'
import UGE from 'creation/src/components/uge-gl'
import { UGERef } from 'creation/src/components/uge-gl/types'
import { useContext, useRef, useState } from 'react'
import styled from 'styled-components'
import Button from 'ui/src/components/controls/button'
import { WEB_API_KEY } from '../../../../../shared/api'
import { CreationToolsContext } from '../../../manager'
import { validateSourceByOutput } from '../../../utils/validate-source'
import { CreationToolUploadContext } from '../manager'
import Modal from './modal'

const SaveButton = styled(Button)`
    bottom: 0;
    position: sticky;
    margin: 10px auto;
    width: 100%;
    z-index: 2;
`

const CreationUploadEditor = () => {
    const ugeRef = useRef<UGERef>(null)
    const { apiKey } = useContext(CreationToolsContext)
    const { editing, setEditing, updateUploadSource } = useContext(CreationToolUploadContext)
    const [isSaving, setIsSaving] = useState<boolean>(false)

    if (!editing) {
        return null
    }

    const {
        defaultEditor,
        source: uploadSource,
        source: { edited: editedUploadFile, source: uploadFile },
    } = editing

    function onCancel() {
        setEditing(undefined)
    }

    async function onDone() {
        if (!ugeRef.current) return

        setIsSaving(true)

        const gif = await ugeRef.current.createGIF()

        if (gif) {
            const edited = await validateSourceByOutput(gif, uploadSource.outputType)

            updateUploadSource({
                ...uploadSource,
                edited,
            })
        }

        setEditing(undefined)
        setIsSaving(false)
    }

    return (
        <Modal onCancel={onCancel}>
            <UGE
                apiKey={apiKey || WEB_API_KEY}
                closeable
                defaultEditor={defaultEditor}
                enableStickers
                ref={ugeRef}
                source={editedUploadFile?.source || uploadFile.source}
                onClose={onCancel}
                onGAEvent={(event, options) => setGADataLayer({ event, options })}
            >
                <SaveButton gradient="indigo-purple" loading={isSaving} size="large" onClick={onDone}>
                    Save Changes
                </SaveButton>
            </UGE>
        </Modal>
    )
}

export default CreationUploadEditor
